import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const propTypes = {
  isActive: PropTypes.bool,
};

const defaultProps = {
  isActive: false,
};

const useStyles = makeStyles(() => ({
  roundedButton: {
    borderRadius: '50%',
    height: 36,
    width: 36,
    minWidth: 36,
  },
}));

function PageLink(props) {
  const classes = useStyles();
  const { isActive, ...others } = props;
  return (
    <Button
      variant={isActive ? 'contained' : 'text'}
      color={isActive ? 'primary' : 'inherit'}
      classes={{ root: classes.roundedButton }}
      size="small"
      {...others}
    />
  );
}

PageLink.propTypes = propTypes;
PageLink.defaultProps = defaultProps;

export default PageLink;
